/**
 * Pure TEA update for image alt-text dialog draft.
 *
 * Shell: `ImageAltDialog.vue` (prop `open` drives Seed + focus Cmd).
 */
import { assertNever } from "../lib/assertNever";
import type { UpdateFn } from "../lib/tea";

export type ImageAltDialogModel = {
  readonly draft: string;
};

export const initialImageAltDialogModel: ImageAltDialogModel = {
  draft: "",
};

export type ImageAltDialogMsg =
  | { readonly type: "Seed"; readonly alt: string }
  | { readonly type: "DraftChanged"; readonly draft: string }
  | { readonly type: "Apply" };

export type ImageAltDialogCmd =
  | { readonly kind: "focusInput" }
  | { readonly kind: "apply"; readonly alt: string };

export function updateImageAltDialog(
  model: ImageAltDialogModel,
  msg: ImageAltDialogMsg,
): readonly [ImageAltDialogModel, readonly ImageAltDialogCmd[]] {
  switch (msg.type) {
    case "Seed":
      return [{ draft: msg.alt }, [{ kind: "focusInput" }]];
    case "DraftChanged":
      return [{ draft: msg.draft }, []];
    case "Apply":
      return [model, [{ kind: "apply", alt: model.draft.trim() }]];
    default:
      return assertNever(msg);
  }
}

export const updateImageAltDialogFn: UpdateFn<
  ImageAltDialogModel,
  ImageAltDialogMsg,
  ImageAltDialogCmd
> = updateImageAltDialog;
